import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useOrdemCompraListaCancelarFilters
 */

type State = {
  centroCusto: number[] | null;
  fornecedor: number[] | null;
  coletaPreco: number[] | null;
  ordemCompra: number[] | null;
  produtoServico: number[] | null;
  status: number[] | null;
  statusNF: number;
  nroNotaFiscal: string | null;
  dataOCStart: Date | null;
  dataOCEnd: Date | null;
};

export const initialOrdemCompraListaCancelarFilters: State = {
  centroCusto: null,
  fornecedor: null,
  coletaPreco: null,
  ordemCompra: null,
  produtoServico: null,
  status: null,
  statusNF: 1,
  nroNotaFiscal: null,
  dataOCStart: null,
  dataOCEnd: null,
}

export const useOrdemCompraListaCancelarFilters = create<State>((set) => ({
  ...initialOrdemCompraListaCancelarFilters,
}));